
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { PlanningShift } from '../models/planning/PlanningShift'
import { RunsheetShift } from '../models/runsheet/RunsheetShift'
import { upsertMultiplePlanningShifts } from '../slices/planningShiftsSlice'
import { upsertMultipleRunsheetShifts } from '../slices/runsheetShiftsSlice'

type SaveShiftPayload = {
  shift: Record<string, unknown>
}

export const saveShift = createAsyncThunk<void, SaveShiftPayload, ThunkApiContext>(
  'schedule/saveShift',
  async ({ shift }, { getState, dispatch }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen
    const endpoint = currentScreen === 'planning' ? '/planning/saveShift' : '/runsheet/saveShift'

    if (currentScreen === 'planning') {
      const planningShift = await OLMSApiService.post<PlanningShift>(endpoint, shift)

      dispatch(upsertMultiplePlanningShifts([planningShift]))
    }
    else {
      const runsheetShift = await OLMSApiService.post<RunsheetShift>(endpoint, shift)

      dispatch(upsertMultipleRunsheetShifts([runsheetShift]))
    }
  },
)
